import { render, staticRenderFns } from "./HomeHours.vue?vue&type=template&id=99ba522a"
import script from "./HomeHours.vue?vue&type=script&lang=js"
export * from "./HomeHours.vue?vue&type=script&lang=js"
import style0 from "./HomeHours.vue?vue&type=style&index=0&id=99ba522a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports